export const SIDEBAR_CLOSED_WIDTH = 70;
export const SIDEBAR_OPEN_WIDTH = 250;
